import { SimpleGrid, Text, VStack } from '@chakra-ui/react'
import React from 'react'
import VideoItem from './video-item'

const videos = [
  {
    url: 'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/crow-feet-1710923632197.mp4',
    title: 'CROW FEET'
  },
  {
    url: 'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/dry-skin-1711001870052.mp4',
    title: 'DRY SKIN'
  },
  {
    url: 'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/pores-1710925401786.mp4',
    title: 'PORES'
  },
  {
    url: 'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/smile-line-1710925282243.mp4',
    title: 'SMILE LINES'
  },
  {
    url: 'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/under-eye-1710925336506.mp4',
    title: 'UNDER EYES'
  },
  {
    url: 'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/moisture-1710925173776.mp4',
    title: 'MOISTURIZING EFFECT'
  },
  {
    url: 'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/glowing-effect-1710925076166.mp4',
    title: 'GLOWING EFFECT'
  },
  {
    url: 'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/nine-in-one-1710925701510.mp4',
    title: '9 IN 1 EFFECT'
  }
]

const Videos = () => {
  return (
    <VStack gap={10}>
      <Text
        fontSize={32}
        fontWeight={400}
        textTransform="uppercase"
        textAlign="center"
      >
        SEE IT TO BELIEVE IT
      </Text>
      <SimpleGrid
        columns={{ base: 1, sm: 2, md: 2, lg: 2 }}
        gap={{
          base: 4,
          md: 10
        }}
        w={'100%'}
      >
        {videos.map((video, index) => (
          <VideoItem key={index} title={video.title} url={video.url} />
        ))}
      </SimpleGrid>
    </VStack>
  )
}

export default Videos
